<template>
  <div v-if="this.insurance.length > 0 && this.reportData.length > 0 ">
    <v-card elevation="2">
      <v-row justify="space-between">
        <v-col cols="6" sm="8" class="py-0">
          <v-card-title primary-title>{{ this.reportMode }} Funding and Expense</v-card-title>
        </v-col>
        <v-col cols="6" sm="4" lg="2" class="py-0">
          <v-switch color="secondary" inset v-model="pmpm" class="float-right">
            <template slot="prepend">
              <p class="pt-1 mr-2">{{ this.toggleName }}</p>
            </template>
          </v-switch>
        </v-col>
      </v-row>
      <v-data-table
        :loading="load"
        :headers="headers"
        :items="reportData"
        :search="search"
        :sort-by="['reportData.START_DATE']"
        :sort-desc="[true]"
        :footer-props="{
          'items-per-page-options': [12, 24, -1]
        }"
        :items-per-page="12"
        @update:pagination="getMore()"
        multi-sort
        loading-text="Loading data..."
        class="elevation-0 col-md-12 m-auto"
      >
      <template v-slot:item.IBNR="{ item }">
        {{item.IBNR ? item.IBNR: '$0.00'}}
      </template>
      <template v-slot:item.PlanShare="{ item }">
        {{item.PlanShare ? item.PlanShare: '$0.00'}}
      </template>
      <template v-slot:item.Reserve="{ item }">
        {{item.Reserve ? item.Reserve: '$0.00'}}
      </template>
        <template slot="body.append" v-if="reportData.length > 0">
          <tr>
            <th class="subtitle-2 text--primary font-weight-bold">Totals</th>
            <th v-if="insurance === 'Humana' || insurance ==='Careplus'"></th>
            <th
              v-for="column in columnTotals"
              class="subtitle-2 text--primary font-weight-bold"
            >{{ sumField(column.value) }}</th>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FundingExpense',
  props: [
    'organization',
    'groups',
    'providers',
    'locations',
    'insurance',
    'startDate',
    'endDate',
    'data',
    'reportType'
  ],
  data() {
    return {
      search: '',
      load: false,
      pagination: '',
      reportData: [],
      headers: [],
      pmpm: false,
      cancelSource: null,
    };
  },
  methods: {
    async getHeaders() {
      const insurance = this.insurance.toLowerCase();

      if (insurance === 'freedom' || insurance === 'optimum') {
        this.headers = [
          { text: 'Month', value: 'Month' },
          { text: 'Member Months', value: 'Member_Months' },
          { text: 'Funding', value: 'Funding' },
          { text: 'Part A Expense', value: 'Part_A' },
          { text: 'Part B Expense', value: 'Part_B' },
          { text: 'Part D Expense', value: 'Part_D' },
          { text: 'PCP Cap Expense', value: 'PCP_Cap' },
          { text: 'Specialist Cap', value: 'Specialist_Cap' },
          { text: 'Manual Adjustment', value: 'Manual_Adj' },
          { text: 'IBNR', value: 'IBNR' },
          { text: 'Reinsurance', value: 'Reinsurance' },
          { text: 'Stoploss', value: 'Stoploss' },
          { text: 'Net', value: 'Net' },
        ];
      } else if (insurance === 'humana') {
        this.headers = [
          { text: 'PE Date', value: 'RPT_PE' },
          { text: 'Month', value: 'Month' },
          { text: 'Member Months', value: 'Member_Months' },
          { text: 'Funding', value: 'Funding' },
          { text: 'Withheld', value: 'Withheld' },
          { text: 'Claims Expense', value: 'ClaimsExp' },
          { text: 'Cap Expense', value: 'CapExpense' },
          { text: 'Manual Adjustment', value: 'Manual_Adj' },
          { text: 'IBNR', value: 'IBNR' },
          { text: 'Stoploss', value: 'Stoploss' },
          { text: 'Net', value: 'Net' },
        ];
      } else if (insurance === 'careplus') {
        this.headers = [
          { text: 'PE Date', value: 'RPT_PE' },
          { text: 'Month', value: 'Month' },
          { text: 'Member Months', value: 'Member_Months' },
          { text: 'Funding', value: 'Funding' },
          { text: 'Cap Expense', value: 'CapExpense' },
          { text: 'Reinsurance', value: 'Reinsurance' },
          { text: 'Claims Expense', value: 'ClaimsExp' },
          { text: 'Specialty Cap', value: 'SpecialtyCap' },
          { text: 'Manual Adjustment', value: 'Manual_Adj' },
          { text: 'IBNR', value: 'IBNR' },
          { text: 'Reserve', value: 'Reserve' },
          { text: 'Plan Share', value: 'PlanShare' },
        ];
      }
    },
    sumField(key) {
      // filter out all empty/undefined values and sum up what we have
      if (key === 'Member_Months') {
        return this.reportData.filter(f => f.Member_Months != undefined).reduce((a, b) => a + (b[key] || 0), 0);
      }
      const value = this.reportData.filter(f => f[key] != undefined).reduce(
        (a, b) => a + (this.parseCurrency(b[key]) || 0),
        0,
      );
      return `$${this.formatCurrency(value)}`;
    },
    parseCurrency(value) {
      return parseFloat(value.replace(/[^\w\s.-]/gi, ''));
    },
    formatCurrency(c) {
      if (c != undefined) { return c.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'); }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },
  computed: {
    reportMode() {
      if (this.pmpm == true) {
        return 'PMPM';
      }
      return 'Gross';
    },
    toggleName() {
      if (this.pmpm == true) {
        return 'Gross';
      }
      return 'PMPM';
    },
    columnTotals() {
      return this.headers.filter(
        field => field.value !== 'Month' && field.value !== 'RPT_PE',
      );
    },
  },
  watch: {
    async pmpm() {
      this.$emit("pmpm", this.pmpm);
    },
    async data() {
      this.reportData = this.data
      this.getHeaders()
    },
  },
};
</script>